import { PageHeader } from "@/components/PageHeader";
import { Testimonials } from "@/components/sections/Testimonials";
import { StatsBand } from "@/components/sections/StatsBand";
import { CtaBanner } from "@/components/sections/CtaBanner";

export default function Reviews() {
  return (
    <div data-testid="reviews-page">
      <PageHeader
        eyebrow="Customer Stories"
        title={<>Peace of mind, <span className="text-brand-red">in their words.</span></>}
        sub="Thousands of families trust LifeButton every day. Here are a few of the moments that mattered most."
      />
      <StatsBand />
      <Testimonials />
      <CtaBanner />
    </div>
  );
}
